import React from 'react'
import { motion } from 'framer-motion'
import {
  SearchIcon,
  CompassIcon,
  PaletteIcon,
  RocketIcon,
  RefreshCwIcon,
  ChevronRightIcon,
} from 'lucide-react'

type Step = {
  label: string
  icon: React.ReactNode
}

const steps: Step[] = [
  { label: 'UX insight', icon: <SearchIcon className="w-5 h-5" /> },
  { label: 'Product decision', icon: <CompassIcon className="w-5 h-5" /> },
  { label: 'Design', icon: <PaletteIcon className="w-5 h-5" /> },
  { label: 'Production build', icon: <RocketIcon className="w-5 h-5" /> },
  { label: 'Iteration', icon: <RefreshCwIcon className="w-5 h-5" /> },
]

export function FeaturePipeline() {
  return (
    <div className="mb-12">
      <div className="text-center mb-8">
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 font-['Poppins']">
          What's in a feature
        </h3>
        <p className="text-base text-gray-600 max-w-2xl mx-auto font-['Roboto']">
          A greenmango feature isn't a screen someone vibe-coded over a weekend.
          Each one runs the full chain — from real user insight to
          production-ready software you can build on.
        </p>
      </div>

      <ol className="flex flex-col sm:flex-row sm:flex-wrap items-stretch justify-center gap-3 sm:gap-2">
        {steps.map((step, index) => (
          <li key={step.label} className="flex items-center justify-center sm:flex-1 sm:min-w-[140px]">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="flex items-center gap-3 w-full sm:flex-col sm:text-center bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm"
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary flex-shrink-0">
                {step.icon}
              </span>
              <span className="text-sm font-semibold text-gray-900 font-['Poppins'] leading-tight">
                {step.label}
              </span>
            </motion.div>
            {index < steps.length - 1 && (
              <ChevronRightIcon className="hidden sm:block w-5 h-5 text-gray-300 flex-shrink-0 mx-0.5" aria-hidden="true" />
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}